import type { Router } from 'vue-router'
import { setupAuthHook } from './auth'
import { setupRefreshHook } from './refresh'

export function setupRouterHooks(router: Router) {
  setupAuthHook(router)
  setupDocumentTitleHook(router)
  if (import.meta.env.MODE !== 'development') {
    setupRefreshHook(router)
  }
}

/**
 * 更新标题
 */
function setupDocumentTitleHook(router: Router) {
  router.afterEach((to) => {
    const title = to.meta.title
    if (title) document.title = title
  })
}
